module.exports = __webpack_public_path__ + "static/img/funkwerks_logo.66dc190.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/funkwerks_logo.png
// module id = 296
// module chunks = 1